import { DropdownOption } from 'components/final-form/dropdownUtils';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { DropdownProps, Grid } from 'semantic-ui-react';
import { PxDropdownSc } from 'components/final-form/Select';
import AddButton from 'components/AddButton';

interface Props extends MessageSourceProps {
  tariffOptions: DropdownOption[],
  addNewTariff: (tariffId: number) => void
}

interface State {
  selectedTariff?: number
}

class TariffDropdownRow extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  onTariffChange = (tariffId: any) => {
    this.setState({
      selectedTariff: tariffId
    });
  };

  addNewTariff = (selectedTariff: number | undefined) => {
    if (selectedTariff) {
      this.props.addNewTariff(selectedTariff);
      this.setState({
        selectedTariff: undefined
      })
    }
  }

  render(): React.ReactNode {

    const {tariffOptions, getMessage} = this.props;
    const {selectedTariff} = this.state;

    const btnDisabled = !selectedTariff;

    return (
        <>
          <Grid.Row>
            <Grid.Column width={3}>
              <label>{getMessage("location.tariff")}</label>
            </Grid.Column>
            <Grid.Column width={10}>
              <PxDropdownSc
                  value={selectedTariff}
                  onChange={
                    (e: any, {value}: DropdownProps) => this.onTariffChange(value)
                  }
                  options={tariffOptions}
                  selection
                  searchable
                  fluid
              />
            </Grid.Column>

            <Grid.Column width={3}>
              <AddButton buttonMessage={getMessage("button.add")}
                         onClick={() => this.addNewTariff(selectedTariff)}
                         type="button"
                         disabled={btnDisabled}
              />
            </Grid.Column>
          </Grid.Row>
        </>

    );
  }

}

export default withMessages(TariffDropdownRow);
